import { render, staticRenderFns } from "./modal-video.vue?vue&type=template&id=78ab1885&scoped=true&"
import script from "./modal-video.vue?vue&type=script&lang=js&"
export * from "./modal-video.vue?vue&type=script&lang=js&"
import style0 from "./modal-video.vue?vue&type=style&index=0&id=78ab1885&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ab1885",
  null
  
)

export default component.exports